import { Loading } from "@/components/ui/loading";
import { Tours } from "@/modules/tours/routes/tours.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/tours/")({
	component: Tours,
	pendingComponent: Loading,
});
